<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="客户">
              <a-select
                v-model="query.corpId"
                placeholder="键入名字选择企业"
                :allowClear="true"
                :filterOption="false"
                class="hundred"
                showSearch
                @search="loadCorps"
                @change="corpSelectedChange"
                :notFoundContent="corpLoading ? undefined : '没有符合的企业'">
                <a-spin v-if="corpLoading" slot="notFoundContent" size="small"/>
                <a-select-option v-for="item in corps" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="MAC地址">
                <a-input v-model="query.mac" placeholder=""/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="机芯">
                <a-input v-model="query.chip" placeholder=""/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="query.status" placeholder="请选择" default-value="1">
                  <a-select-option value="true">在线</a-select-option>
                  <a-select-option value="false">离线</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="软件版本">
                <a-input v-model="query.pkgVersion" placeholder=""/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="fetchData">查询</a-button>
              <a-button style="margin-left:8px" @click="clearData">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-dropdown>
        <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="check-circle" />激活</a-menu-item>
          <a-divider style="margin:5px 0"/>
          <a-menu-item key="2"><a-icon type="close-circle" />注销</a-menu-item>
          <a-divider style="margin:5px 0"/>
          <a-menu-item key="3"><a-icon type="cloud-download" />pkg安装</a-menu-item>
          <a-divider style="margin:5px 0"/>
          <a-menu-item key="3"><a-icon type="cloud-download" />apk安装</a-menu-item>
          <a-divider style="margin:5px 0"/>
          <a-menu-item key="3"><a-icon type="setting" />克隆设置</a-menu-item>
        </a-menu>
        <a-button type="primary">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <a-table
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="false">
      <template slot="mac" slot-scope="text">
        <router-link to="#">{{ text }}</router-link>
      </template>
      <!--      <template slot="corpId" slot-scope="value">-->
      <!--      </template>-->
      <template slot="status" slot-scope="value" v-if="true">
        <a-tag :color="value===true?'#87d068':'#ea7070'">在线</a-tag>
      </template>
      <template slot="active" slot-scope="value">
        <a-tag :color="value===true?'green':'orange'">未激活</a-tag>
      </template>
    </a-table>
    <a-modal
      :visible="visible.edit"
      :okButtonProps="{ props: {disabled: false} }"
      title="编辑用户">
      <template slot="footer">
        <a-button type="danger" style="float: left">重置密码</a-button>
        <a-button key="back" @click="visible.edit = false">取消</a-button>
        <a-button key="submit" type="primary" @click="visible.edit = false">保存</a-button>
      </template>
      <a-spin :spinning="false">
        <a-form>
          <a-form-item label="账号" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input value="zhangsan" disabled placeholder="输入用户账号" />
          </a-form-item>
          <a-form-item label="所属公司" :labelCol="{span: 5}" :wrapperCol="{span: 17}">
            <a-select
              value="长虹国际酒店"
              placeholder="选择公司"
              :allowClear="true"
              :filterOption="false"
              optionFilterProp="children"
              class="hundred">
              <a-select-option v-for="item in corps" :key="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="姓名" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input value="张三" placeholder="输入用户姓名" />
          </a-form-item>
          <a-form-item label="手机号码" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input value="13880129025" placeholder="输入手机号码" />
          </a-form-item>
          <a-form-item label="邮箱" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input value="13880129025@qq.com" placeholder="输入邮箱" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
import { convertToPagination } from '@/utils/util'
import { pageDevice } from '@/api/device'
import { pageCorp } from '@/api/corp'

const columns = [
  {
    title: 'MAC地址',
    dataIndex: 'mac',
    scopedSlots: { customRender: 'mac' }
  },
  {
    title: '企业',
    dataIndex: 'corpName'
  },
  {
    title: '型号',
    dataIndex: 'model'
  },
  {
    title: '软件版本',
    dataIndex: 'pkgVersion'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '是否激活',
    dataIndex: 'active',
    scopedSlots: { customRender: 'active' }
  }
]

export default {
  name: 'DeviceManager',

  data () {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      advanced: false,
      corpLoading: false,
      okLoading: false,
      visible: {
        edit: false
      },
      query: {
        corpId: '',
        mac: '',
        status: '',
        model: '',
        chip: '',
        pkgVersion: '',
        apkVersion: '',
        prop: '',
        direction: '',
        pageSize: 10,
        pageNumber: 0
      },
      page: {
        content: [],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [],
      selectedRows: [],
      editingUser: {},
      corps: []
    }
  },

  computed: {
    rowSelection () {
      const ctx = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          ctx.unitIds = selectedRowKeys
          console.log(ctx.unitIds)
        }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    clearData () {
      // Object.keys(this.query).forEach(key =>this.query[key]='')
      this.query.mac = ''
      this.query.status = ''
      this.query.chip = ''
      this.query.corpId = ''
      this.query.pkgVersion = ''
      this.fetchData()
    },

    fetchData () {
      this.loading = true
      pageDevice(this.query).then(response => {
        this.page = response.data
        this.pagination = convertToPagination(this.page, this.pagination)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    loadCorps (val) {
      this.corpLoading = true
      const query = {
        name: val,
        pageSize: 50,
        pageNumber: 0
      }
      pageCorp(query).then(response => {
        this.corps = response.data.content
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.corpLoading = false
      })
    },

    corpSelectedChange (val) {
      this.query.corpId = val
      this.fetchData()
    },

    loadDevice (val) {
      this.corpLoading = true
      const query = {
        name: val,
        pageSize: 50,
        pageNumber: 0
      }
      pageCorp(query).then(response => {
        this.corps = response.data.content
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.corpLoading = false
      })
    },

    handleEdit (record) {
      this.visible.edit = true
    },

    handleOk () {

    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style lang="less" scoped>
  .forty {
    width: 40%;
  }
  .sixty {
    width: 60%;
  }
  .hundred {
    width: 100%;
  }
</style>
